module.exports = __webpack_public_path__ + "static/media/card-obstetricia.93ee345e.svg";